import * as http from "./http";
import { ApiResponse, ListSort, PaginatedApiResponse } from "../models";
import ApiService from "./service";
import { Dict } from "../../models";
import { Project, PropertySyncResponse } from "../models/project";

export class ProjectService extends ApiService {
  public async getProjectDetails(id: string): Promise<{ project: Project }> {
    const url = `${this.apiDomain}/api/project/${id}`;
    const response = await http.get<ApiResponse<{ project: Project }>>(url, this.store);
    return response?.data?.data;
  }
  public async getProjectList(
    data: {
      page?: number;
      search?: string;
      perPage?: number;
    } & ListSort &
      Dict
  ): Promise<PaginatedApiResponse<Project[]>> {
    const url = `${this.apiDomain}/api/project/list`;
    const response = await http.post<PaginatedApiResponse<Project[]>>(url, data, this.store);

    return response?.data;
  }

  public async getProperties(id: string): Promise<{ project: Project }> {
    const url = `${this.apiDomain}/api/property?projectID=${id}`;
    const response = await http.get<ApiResponse<{ project: Project }>>(url, this.store);
    return response?.data?.data;
  }

  public async getProjectByKey(query: string): Promise<Project[]> {
    const url = `${this.apiDomain}/api/project/search`;
    const response = await http.post<ApiResponse<Project[]>>(
      url,
      {
        query,
      },
      this.store
    );
    return response?.data?.data;
  }

  public async getTenantHistory(projectID: number, isMasterTenancy?: boolean): Promise<{ project: Project }> {
    const url = `${this.apiDomain}/api/tenant-history/list`;
    const response = await http.post<ApiResponse<{ project: Project }>>(
      url,
      {
        projectID,
        isMasterTenancy,
      },
      this.store
    );
    return response?.data?.data;
  }

  public async syncEcom(): Promise<{ status: number; data: PropertySyncResponse }> {
    const url = `${this.apiDomain}/api/project/sync-ecom`;
    const response = await http.post<ApiResponse<PropertySyncResponse>>(url, {}, this.store);
    return response?.data;
  }
}
